// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-stepper-item {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: none;
  opacity: var(--v-medium-emphasis-opacity);
  padding: 1.5rem;
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.v-stepper-item--selected {
  opacity: 1;
}
.v-stepper-item--error {
  color: rgb(var(--v-theme-error));
}
.v-stepper-item--disabled {
  opacity: var(--v-medium-emphasis-opacity);
  pointer-events: none;
}
.v-stepper--alt-labels .v-stepper-item {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 175px;
}

.v-stepper-item__avatar.v-avatar {
  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));
  color: rgb(var(--v-theme-on-surface-variant));
  font-size: 0.75rem;
  margin-inline-end: 8px;
}
.v-stepper-item__avatar.v-avatar .v-icon {
  font-size: 0.875rem;
}
.v-stepper-item--selected .v-stepper-item__avatar.v-avatar, .v-stepper-item--complete .v-stepper-item__avatar.v-avatar {
  background: rgb(var(--v-theme-surface-variant));
}
.v-stepper-item--error .v-stepper-item__avatar.v-avatar {
  background: rgb(var(--v-theme-error));
}
.v-stepper--alt-labels .v-stepper-item__avatar.v-avatar {
  margin-bottom: 16px;
  margin-inline-end: 0;
}

.v-stepper-item__title {
  line-height: 1;
}
.v-stepper--mobile .v-stepper-item__title {
  display: none;
}

.v-stepper-item__subtitle {
  font-size: 0.75rem;
  text-align: left;
  line-height: 1;
  opacity: var(--v-medium-emphasis-opacity);
}
.v-stepper--alt-labels .v-stepper-item__subtitle {
  text-align: center;
}
.v-stepper--mobile .v-stepper-item__subtitle {
  display: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VStepper/VStepperItem.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kFAAkF;EAClF,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf","sourcesContent":[".v-stepper-item {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: none;\n  opacity: var(--v-medium-emphasis-opacity);\n  padding: 1.5rem;\n  transition-duration: 0.2s;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-stepper-item--selected {\n  opacity: 1;\n}\n.v-stepper-item--error {\n  color: rgb(var(--v-theme-error));\n}\n.v-stepper-item--disabled {\n  opacity: var(--v-medium-emphasis-opacity);\n  pointer-events: none;\n}\n.v-stepper--alt-labels .v-stepper-item {\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  flex-basis: 175px;\n}\n\n.v-stepper-item__avatar.v-avatar {\n  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));\n  color: rgb(var(--v-theme-on-surface-variant));\n  font-size: 0.75rem;\n  margin-inline-end: 8px;\n}\n.v-stepper-item__avatar.v-avatar .v-icon {\n  font-size: 0.875rem;\n}\n.v-stepper-item--selected .v-stepper-item__avatar.v-avatar, .v-stepper-item--complete .v-stepper-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-surface-variant));\n}\n.v-stepper-item--error .v-stepper-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-error));\n}\n.v-stepper--alt-labels .v-stepper-item__avatar.v-avatar {\n  margin-bottom: 16px;\n  margin-inline-end: 0;\n}\n\n.v-stepper-item__title {\n  line-height: 1;\n}\n.v-stepper--mobile .v-stepper-item__title {\n  display: none;\n}\n\n.v-stepper-item__subtitle {\n  font-size: 0.75rem;\n  text-align: left;\n  line-height: 1;\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-stepper--alt-labels .v-stepper-item__subtitle {\n  text-align: center;\n}\n.v-stepper--mobile .v-stepper-item__subtitle {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
